import { makeAutoObservable } from "mobx";
import { ModalStore } from "./ModalStore";
import { SheetStore } from "./SheetStore";

export class UIStore {
	modalStore: ModalStore;
	sheetStore: SheetStore;
	theme: "light" | "dark" = "light";

	constructor() {
		this.modalStore = new ModalStore();
		this.sheetStore = new SheetStore();
		makeAutoObservable(this);
	}

	setTheme(theme: "light" | "dark") {
		this.theme = theme;
	}
}
